import { type Moment } from "moment"
import { OrderRepository } from "@/repositories/order-repository"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"
import { Order } from "@/models/order.model"

export function useOrdersAPIFunctions() {
  async function retrieveOrdersDuringDateRange(
    instructionsDateStart: Moment,
    instructionsDateEnd: Moment,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    excludeOrderIds: string[] = []
  ) {
    // Both bounds stay inside ONE any(): the window must be satisfied by a single
    // instruction. Two separate any() calls would match an order with one instruction
    // before the window and another after it, but none inside.
    const query = new ODataQueryBuilder().raw("instructionsInWindow", {
      instructions: {
        any: {
          date: {
            ge: instructionsDateStart.format("YYYY-MM-DD"),
            le: instructionsDateEnd.format("YYYY-MM-DD")
          }
        }
      }
    })

    const response = await new OrderRepository().getList({ query })
    return response.data.map((order) => new Order(order))
  }

  return {
    retrieveOrdersDuringDateRange
  }
}
